var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvailableForWorkNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "available_for_work_new_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#available_for_work_new_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.8 20.5c-.5 0-.925-.175-1.275-.525A1.736 1.736 0 013 18.7V8.3c0-.5.175-.925.525-1.275.35-.35.775-.525 1.275-.525H9V4.8c0-.5.175-.925.525-1.275C9.875 3.175 10.3 3 10.8 3h3.4c.5 0 .925.175 1.275.525.35.35.525.775.525 1.275v1.7h4.2c.5 0 .925.175 1.275.525.35.35.525.775.525 1.275v4.25a4.88 4.88 0 00-.712-.425 5.168 5.168 0 00-.788-.3V8.3a.292.292 0 00-.087-.213A.292.292 0 0020.2 8H4.8a.289.289 0 00-.212.087.29.29 0 00-.088.213v10.4c0 .083.03.154.088.213A.289.289 0 004.8 19h7.275c.05.267.108.525.175.775.067.25.15.492.25.725H4.8zm5.7-14h4V4.8a.292.292 0 00-.087-.213.292.292 0 00-.213-.087h-3.4a.289.289 0 00-.212.087.29.29 0 00-.088.213v1.7z",
    fill: "#555"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.399,
    cy: 17.997,
    r: 5.2,
    fill: "#66CC80"
  }))));
}
export default __webpack_public_path__ + "assets/static/media/available_for_work_new.47197bdf.svg";
export { SvgAvailableForWorkNew as ReactComponent };